(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["apiz-new-badge"] && !Shopify.designMode) return;
  try {
    (() => {
    let timer;
    const refresh = () => {
      clearTimeout(timer);
      const now = Date.now();
      let next = Infinity;
      document.querySelectorAll('[data-apiz-new-created][data-apiz-new-expires]').forEach((badge) => {
        const created = Number(badge.dataset.apizNewCreated) * 1000;
        const expires = Number(badge.dataset.apizNewExpires) * 1000;
        const eligible = Number.isFinite(created) && created > 0 &&
          Number.isFinite(expires) && expires - created === 2592000000 &&
          created <= now && now < expires;
        badge.hidden = !eligible;
        if (eligible) next = Math.min(next, expires - now);
      });
      if (Number.isFinite(next)) timer = setTimeout(refresh, Math.min(next, 86400000));
    };
    refresh();
    window.addEventListener('pageshow', refresh);
    document.addEventListener('visibilitychange', refresh);
    document.addEventListener('shopify:section:load', refresh);
    new MutationObserver((records) => {
      if (records.some((record) => [...record.addedNodes].some((node) =>
        node.nodeType === 1 && (node.matches('[data-apiz-new-expires]') ||
          node.querySelector('[data-apiz-new-expires]'))))) refresh();
    }).observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
